import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { ghgCategoryField } from './common/sharedFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productFields, purchasedMaterialFields } from './common/productFields';
import {
  beaCodeField,
  currencyQuantityField,
  expenditureFields,
} from './common/expenditureFields';
import { msg } from '@lingui/core/macro';

export const expenditureMappedMetadata = {
  displayName: msg({
    message: 'Expenses',
    context: 'Activity data schema name for expenditure',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    ...purchasedMaterialFields,
    ...expenditureFields,
    // NOTE: quantity does not exist on the BAT but currency_quantity is
    // renamed to quantity in the BART-EM matching process
    quantity: currencyQuantityField,
    bea_code: beaCodeField,
    expenditure_category: {
      displayName: msg({
        message: 'Expenditure category',
        context: 'The display name for expenditure category field',
      }),
    },
    ghg_category: ghgCategoryField,
  },
} as const satisfies BatMetadataConfigEntry;
